import { useMutation } from '@tanstack/react-query'
import { useInvalidateQueries } from '../../../../../hooks/useInvalidateQueries'
import { markRequestAsDangerous } from '../../../../../services/ApiService'
import { closeModalFn } from '../../../../../utils/controllers/ModalController'
import { newRequestDrawerStore } from '../../../../RequestsManagement/stores/NewRequestDrawerStore'
import { REQUEST_KEYS } from '../../../../SingleRequestPage/consts/request-keys'
import singleRequestStore from '../../../../SingleRequestPage/store/SingleRequestStore'

export const useMarkAsDangerous = (checkboxStore?: any) => {
  const invalidate = useInvalidateQueries()

  const { mutateAsync } = useMutation({
    mutationKey: ['mark-as-dangerous'],
    mutationFn: (id?: number) =>
      markRequestAsDangerous({
        orderIds: id ? [id] : [...checkboxStore?.selectedIds],
        isDangerous: true,
      }),
    onSuccess: () => {
      checkboxStore?.resetAll(true)
      invalidate(['requests-table', REQUEST_KEYS.REQUEST])
      singleRequestStore.updateHistory()
      newRequestDrawerStore.updateRequest({ isDangerous: true })
      closeModalFn['progress-backdrop']?.()
    },
    onError: () => {
      closeModalFn['progress-backdrop']?.()
    },
  })

  const { mutateAsync: unmarkAsync } = useMutation({
    mutationKey: ['unmark-as-dangerous'],
    mutationFn: (id?: number) =>
      markRequestAsDangerous({
        orderIds: id ? [id] : [...checkboxStore?.selectedIds],
        isDangerous: false,
      }),
    onSuccess: () => {
      checkboxStore?.resetAll(true)
      newRequestDrawerStore.updateRequest({ isDangerous: false })
      invalidate(['requests-table', REQUEST_KEYS.REQUEST])
      singleRequestStore.updateHistory()
      closeModalFn['progress-backdrop']?.()
    },
    onError: () => {
      closeModalFn['progress-backdrop']?.()
    },
  })

  const markAsDangerousFn = (id?: number) => {
    mutateAsync(id)
  }

  const unmarkAsDangerousFn = (id?: number) => {
    unmarkAsync(id)
  }

  return { markAsDangerousFn, unmarkAsDangerousFn }
}
